import styled from "@emotion/styled";

import { css } from "@emotion/react";
import { HTMLAttributes } from "react";

interface SpacingProps extends HTMLAttributes<HTMLDivElement> {
  gap: number;
  orientation?: "vertical" | "horizontal";
}

const SpacingBase = styled.div<{
  gap: number;
  orientation?: "vertical" | "horizontal";
}>`
  flex-shrink: 0;
  ${({ gap, orientation = "vertical" }) => {
    switch (orientation) {
      case "vertical":
        return css`
          margin-top: ${gap}px!important;
        `;
      case "horizontal":
        return css`
          margin-left: ${gap}px!important;
        `;
    }
  }}
`;

// 래퍼 컴포넌트로 className 추가 및 모든 HTML attributes 지원
export const Spacing = ({
  gap,
  orientation = "vertical",
  className,
  ...rest
}: SpacingProps) => {
  return (
    <SpacingBase
      gap={gap}
      orientation={orientation}
      className={`goi-spacing ${className || ""}`}
      {...rest}
    />
  );
};
